<template>
  <div>
    <tabs
      v-model="active"
      color="#4FD9D5"
      title-active-color="#4FD9D5"
      title-inactive-color="#999999"
      line-width="25%"
      :border="true"
      sticky
    >
      <tab v-for="(item, index) in tabs" :key="index" :title="item">
        <list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div>
            <coupon :list="list" @use="clickCoupon" />
          </div>
        </list>
      </tab>
    </tabs>
  </div>
</template>

<script>
/**
@description:优惠券
@createTime:2021-09-23
@create:wq
*/
import { Tab, Tabs, List } from "vant";
import coupon from "@/views/mine/coupon/couponComponent.vue";
export default {
  name: "",
  components: { Tab, Tabs, List, coupon },
  data() {
    return {
      active: 0,
      tabs: ["待使用", "已失效"],
      loading: false,
      finished: true,
      list: [],
      page: 1,
    };
  },
  computed: {},
  watch: {
    active() {
      this.couponList();
    },
  },
  mounted() {},
  created() {
    this.couponList();
  },
  methods: {
    onLoad() {
      //   this.couponList();
      //   this.page++;
    },
    couponList() {
      this.api.couponList({ status: this.active + 1 }).then((res) => {
        this.list = res.data;
        //   if (res.data.to < res.data.per_page) {
        //     this.loading = true;
        //     this.finished = true;
        //   } else {
        this.loading = false;
        //   }
      });
    },
    clickCoupon() {
      this.$router.push("teacherList");
    },
  },
};
</script>
<style scoped></style>
